import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import { useRoute } from "vue-router";
import AppLayout from "@/layouts/AppLayout.vue";
import InstallBanner from "@/components/pwa/InstallBanner.vue";
import "@/assets/scss/main.scss";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const layout = computed(() => route.meta.layout);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { theme: "lightTheme" }, {
    default: _withCtx(() => [
      (layout.value === 'AppLayout')
        ? (_openBlock(), _createBlock(AppLayout, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_router_view, { key: 1 })),
      _createVNode(InstallBanner)
    ]),
    _: 1
  }))
}
}

})